import { List } from '@mui/material';
import { DashboardShareCollaboratorListItem } from '../DashboardShareCollaboratorListItem';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';

export const DashboardShareCollaboratorList = () => {
  const dashboard = useDashboardStore(({ dashboard }) => dashboard);
  if (!dashboard) {
    return null;
  }

  const creator = dashboard?.createdBy;
  const collaboratorList = dashboard.editors;

  return (
    <List>
      <DashboardShareCollaboratorListItem
        key={creator.id}
        user={creator}
        dashboard={dashboard}
        isCreator
      />
      {collaboratorList
        ? collaboratorList.map((collaborator) => (
            <DashboardShareCollaboratorListItem
              key={collaborator.id}
              user={collaborator}
              dashboard={dashboard}
            />
          ))
        : null}
    </List>
  );
};
